<template>
  <div
    id="events-best-played-component"
    v-show="getHideBestPlayedWidget === false"
  >
    <default-events-best-played-widget
      v-if="getGameConsole == 'default' && showBestPlayed === true"
    ></default-events-best-played-widget>
    <events-best-played-widget-market-view
      v-if="getGameConsole == 'marketview' && showBestPlayed === true"
    ></events-best-played-widget-market-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'

const DefaultEventsBestPlayedWidget = () => ({
  component: import(
    '@/components/center_widgets/Previews/DefaultEventsBestPlayedWidget'
  ),
  loading: LoadingSkeleton,
  timeout: 200,
})

const EventsBestPlayedWidgetMarketView = () => ({
  component: import(
    '@/components/center_widgets/Previews/EventsBestPlayedWidgetMarketView'
  ),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'EventsBestPlayedWidget',
  components: {
    DefaultEventsBestPlayedWidget,
    EventsBestPlayedWidgetMarketView,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
      getHideBestPlayedWidget: 'odds/getHideBestPlayedWidget',
      showBestPlayed: 'uiConfig/showBestPlayed',
    }),
  },
}
</script>

<style></style>
